import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { i18n } from './i18n'
import '../node_modules/highlight.js/styles/github.css'
import {Plugin_i18nT2} from "@/i18n/i18nString";

Vue.config.productionTip = false

Vue.use(Plugin_i18nT2)
new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: h => h(App),
}).$mount('#app')
